export const SERVICE_CODE = 'PRODUCTION' + '_SERVICE';
